import { createReducer } from "@reduxjs/toolkit";
import { GlobalEntityType } from "shared/types";
import { setKnowledgeBaseItemsFilterExcludedTags, setKnowledgeBaseItemsFilterIncludedTags, setKnowledgeBaseItemsSearchQuery, } from "store/knowledge-base-items-list/knowledge-base-items-list.actions";
import { loadWorkspacesList, loadWorkspacesListFailure, loadWorkspacesListSuccessful, setWorkspacesNameSortingDirection, setWorkspacesLastAccessedSortingDirection, setDuplicatedWorkspaceId, exportWorkspace, exportWorkspaceSuccessful, exportWorkspaceFailure, validateWorkspaceForImportSuccessful, importWorkspaceSuccessful, resetValidatedWorkspaceForImport, } from "./ps-workspace-list.actions";
import initialState from "./ps-workspace-list.store";
import { prepareWorkspacesList } from "./ps-workspace-list.utils";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(loadWorkspacesList, (state) => {
        state.workspacesLoading = true;
    })
        .addCase(setKnowledgeBaseItemsSearchQuery, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.PsWorkspace) {
            state.workspacesSearchQuery = payload.query;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterIncludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.PsWorkspace) {
            state.workspacesTagsFilters.included = payload.tags;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterExcludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.PsWorkspace) {
            state.workspacesTagsFilters.excluded = payload.tags;
        }
    })
        .addCase(setWorkspacesNameSortingDirection, (state, { payload }) => {
        state.workspacesSortingDirections.name = payload;
    })
        .addCase(setWorkspacesLastAccessedSortingDirection, (state, { payload }) => {
        state.workspacesSortingDirections.lastAccessed = payload;
    })
        .addCase(setDuplicatedWorkspaceId, (state, { payload }) => {
        state.duplicatedWorkspaceId = payload;
    })
        .addCase(validateWorkspaceForImportSuccessful, (state, { payload }) => {
        state.importedWorkspace = payload;
    })
        .addCase(importWorkspaceSuccessful, (state) => {
        state.importedWorkspace = null;
    })
        .addCase(resetValidatedWorkspaceForImport, (state) => {
        state.importedWorkspace = null;
    })
        .addCase(loadWorkspacesListSuccessful, (state, { payload }) => {
        const { locked, unlocked } = prepareWorkspacesList(payload);
        state.lockedWorkspaces = locked;
        state.unlockedWorkspaces = unlocked;
        state.workspacesLoading = false;
    })
        .addCase(loadWorkspacesListFailure, (state) => {
        state.workspacesLoading = false;
    })
        .addCase(exportWorkspace, (state) => {
        state.workspaceExportInProgress = true;
    })
        .addCase(exportWorkspaceSuccessful, (state) => {
        state.workspaceExportInProgress = false;
    })
        .addCase(exportWorkspaceFailure, (state) => {
        state.workspaceExportInProgress = false;
    });
});
